import { render } from "./VendorPaymentsIndex.vue?vue&type=template&id=29ce08e3"
import script from "./VendorPaymentsIndex.vue?vue&type=script&lang=js"
export * from "./VendorPaymentsIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__